import { KoyouKeiyakuService } from "@/service/KoyouKeiyakuService";
import { DialogService } from "@/service/DialogService";
import { KoyouKeiyakuDetail } from "@/types/KoyouKeiyakuDetail";

export function useKoyouKeiyakuModify() {
  const srv = new KoyouKeiyakuService();

  /* 雇用契約書を削除する */
  const modifyKoyouKeiyaku = async (koyouKeiyakuDetail: KoyouKeiyakuDetail | null): Promise<boolean> => {
    if(!koyouKeiyakuDetail) {
      await DialogService.warning({
        title: '雇用契約データが空です。処理を中止します'
      })
      return false
    }

    const dialogResult = await DialogService.warning({
      title: '雇用契約書の変更を行いますか？',
      text: 'この操作は取り消すことができません。',
      confirmButtonText: 'はい',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
    })

    if (!dialogResult.isConfirmed) {
      return false
    }
    
    return await srv.modifyKoyouKeiyaku(koyouKeiyakuDetail);
  };

  return {
    modifyKoyouKeiyaku,
  }
}

